// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HEADER */
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  box-shadow: 1px 2px 4px #89889c;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
}
header .logo-holder {
  height: 100%;
  width: 220px;
  background: #0f1a35;
  padding: 15px;
}
header .logo-holder img {
  position: relative;
  max-width: 100%;
  max-height: 100%;
}
header a {
  color: #a29ffa;
  padding: 0 15px 0 0;
  border: 0;
  cursor: pointer;
}
header a:hover {
  color: #4b58a6;
  border-color: #4b58a6;
  cursor: pointer;
}
header i.fa-envelope,
i.fa-question-circle {
  /* border-right: 1px solid @brpurple; */
  padding: 5px /* 15px */ 5px 0;
}
header a.profile-modal {
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  padding-left: 0;
  transition: 0.3s;
  border: 0;
  margin-right: 15px;
}
header a.profile-modal:hover {
  cursor: pointer;
}
header a.profile-modal .profile-icon i {
  width: 40px;
  min-width: 40px;
  height: 40px;
  padding: 10px;
  border: 1px solid #a29ffa;
  border-radius: 20px;
  font-size: 20px;
  margin-right: 10px;
}
/* SIDEBAR */
nav {
  width: 220px;
  background: #0f1a35;
  height: calc(100vh - 70px);
  position: fixed;
  top: 70px;
  left: 0;
  z-index: 10;
  padding-top: 30px;
}
nav a {
  display: block;
  background: #0f1a35;
  transition: 0.3s;
  padding: 15px;
  color: #a4a3be;
}
nav a:hover,
nav .is-active {
  background: #4b58a6;
  color: white;
}
nav a i {
  text-align: center;
  margin-right: 15px;
  width: 20px;
  font-size: 16px;
}
/* MAIN PAGE */
main {
  position: absolute;
  top: 70px;
  left: 220px;
  width: calc(100vw - 220px);
  height: calc(100vh - 70px);
}
main.no-sidebar {
  left: 0;
  width: 100%;
}
/* PROFILE MODAL */
#profileModal {
  border-top: 1px solid #eee;
  padding: 15px 20px;
  color: #43425d;
  height: auto;
  background: white;
  position: fixed;
  width: auto;
  right: 20px;
  top: 70px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.3);
  z-index: 50;
  border-radius: 0 0 10px 10px;
}
#profileModal .profile-data {
  line-height: 24px;
}
#profileModal .profile-label {
  padding-right: 5px;
  font-weight: 700;
}
#profileModal .profile-data i {
  margin-right: 5px;
}
.issue-count {
  font-size: 16px;
  line-height: 24px;
  padding: 0 8px;
  margin-left: 45% !important;
  border-radius: 20px;
  background: #ce6161;
  color: white;
  width: 26px;
  height: 26px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.less"],"names":[],"mappings":"AAAA,WAAW;AAIX;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AAFJ;AAIA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAFJ;AAIA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAIA;EACI,cAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAFJ;AAIA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AAFF;AAIA;;EADE,uCAAuC;EAGrC,6BAAA;AADJ;AAGA;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AADJ;AAGA;EACE,eAAA;AADF;AAGA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AADF;AACA,YAAY;AAKZ;EACI,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;AAHJ;AAKA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AAHJ;AAKA;;EACI,mBAAA;EACA,YAAA;AAFJ;AAIA;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAFJ;AACA,cAAc;AAKd;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AAHJ;AAKA;EACI,OAAA;EACA,WAAA;AAHJ;AACA,kBAAkB;AAMlB;EACE,0BAAA;EACD,kBAAA;EACA,cAAA;EACA,YAAA;EAEC,iBAAA;EACD,eAAA;EACA,WAAA;EACA,WAAA;EACC,SAAA;EACA,wCAAA;EACA,WAAA;EACA,4BAAA;AALF;AAOA;EACI,iBAAA;AALJ;AAOA;EACI,kBAAA;EACA,gBAAA;AALJ;AAOA;EACE,iBAAA;AALF;AAQA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANF","sourcesContent":["@import (reference) url('../styles.less');\n\n/* HEADER */\n\nheader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: @header-height;\n    box-shadow: 1px 2px 4px @dropshadow;\n    background: white;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 5;\n}\nheader .logo-holder {\n    height: 100%;\n    width: @sidebar-width;\n    background: @logo-holder;\n    padding: 15px;\n}\nheader .logo-holder img {\n    position: relative;\n    max-width:100%;\n    max-height:100%;\n}\nheader a {\n    color: @brpurple;\n    padding: 0 15px 0 0;\n    border: 0;\n    cursor: pointer;\n}\nheader a:hover {\n  color: @mdpurple;\n  border-color: @mdpurple;\n  cursor: pointer;\n}\nheader i.fa-envelope, i.fa-question-circle {\n    /* border-right: 1px solid @brpurple; */\n    padding: 5px /* 15px */ 5px 0;\n}\nheader a.profile-modal {\n    height: auto;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 10px;\n    padding-left: 0;\n    transition: 0.3s;\n    border: 0;\n    margin-right: 15px;\n}\nheader a.profile-modal:hover {\n  cursor: pointer;\n}\nheader a.profile-modal .profile-icon i {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  padding: 10px;\n  border: 1px solid @brpurple;\n  border-radius: 20px;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/* SIDEBAR */\n\nnav {\n    width: @sidebar-width;\n    background: @sidebar-color;\n    height: ~\"calc(100vh - @{header-height})\";\n    position: fixed;\n    top: @header-height;\n    left: 0;\n    z-index: 10;\n    padding-top: 30px;\n}\nnav a {\n    display: block;\n    background: @sidebar-color;\n    transition: 0.3s;\n    padding: 15px;\n    color: @ltgrey;\n}\nnav a:hover, nav .is-active {\n    background: @mdpurple;\n    color: white;\n}\nnav a i {\n    text-align: center;\n    margin-right: 15px;\n    width: 20px;\n    font-size: 16px;\n}\n/* MAIN PAGE */\n\nmain {\n    position: absolute;\n    top: @header-height;\n    left: @sidebar-width;\n    width: ~\"calc(100vw - @{sidebar-width})\";\n    height: ~\"calc(100vh - @{header-height})\";\n}\nmain.no-sidebar {\n    left: 0;\n    width: 100%;\n}\n\n/* PROFILE MODAL */\n#profileModal {\n  border-top: 1px solid #eee;\n\tpadding: 15px 20px;\n\tcolor: @dkgrey;\n\theight: auto;\n\twidth: auto;\n  background: white;\n\tposition: fixed;\n\twidth: auto;\n\tright: 20px;\n  top: @header-height;\n  box-shadow: 0 6px 6px rgba(0,0,0,0.3);\n  z-index: 50;\n  border-radius: 0 0 10px 10px;\n}\n#profileModal .profile-data {\n    line-height: 24px;\n}\n#profileModal .profile-label {\n    padding-right: 5px;\n    font-weight: 700;\n}\n#profileModal .profile-data i {\n  margin-right: 5px;\n}\n\n.issue-count{\n  font-size: 16px;\n  line-height: 24px;\n  padding: 0 8px;\n  margin-left: 45% !important;\n  border-radius: 20px;\n  background: @red;\n  color: white;\n  width: 26px;\n  height: 26px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
